import type { AlertSeverity } from '../types';

// Platform severity scale (spec 11.4): four bands, low → high. The backend's stored severities
// (existential/high/elevated/watch) map onto this single display scale so every surface reads the
// same way. Distinct from the war-game intensity bands (Mild/Moderate/Severe/Extreme) — do not
// conflate the two.
export const SEVERITY_SCALE = ['Watch', 'Material', 'Severe', 'Existential'] as const;

// rank 0 = loudest, so the existing alert-feed sort (most severe first) is preserved.
export const SEVERITY_META: Record<AlertSeverity, { label: string; color: string; rank: number }> = {
  existential: { label: 'Existential', color: 'var(--red)', rank: 0 },
  high: { label: 'Severe', color: 'var(--red)', rank: 1 },
  elevated: { label: 'Material', color: 'var(--gold)', rank: 2 },
  watch: { label: 'Watch', color: 'var(--muted)', rank: 3 },
};

export function severityBand(sev: AlertSeverity): { label: string; color: string; rank: number } {
  return SEVERITY_META[sev] ?? SEVERITY_META.watch;
}
